//#region components/breadcrumbs/breadcrumbs_constants.js
var e = "d-breadcrumbs__item--selected", t = "d-breadcrumbs--inverted";
//#endregion
export { t as BREADCRUMBS_INVERTED_MODIFIER, e as BREADCRUMB_ITEM_SELECTED_MODIFIER };

//# sourceMappingURL=breadcrumbs-constants.js.map